import root from 'window-or-global';

export default function() {
    /**
     * Enum for URLs for the API endpoints.
     *
     */
    let apiContext = '';
    if (root.appContext && root.appContext !== '/') {
        apiContext = root.appContext;
    }
    const {config} = root.__epic_client_state;
    if (config) {
        apiContext = config.apiContext;
    }
    if (!root.location.origin) {
        const port = root.location.port ? `:${root.location.port}` : '';
        root.location.origin = `${root.location.protocol}//${root.location.hostname}${port}`;
    }
    const origin = root.location.origin + apiContext;

    return {
        CODE: {
            REDEEM: `${origin}/api/redeem-code`
        },
        PAYOUT: {
            SAVE: `${origin}/api/payout-save`,
            GET: `${origin}/api/payout-get`
        },
        PRIZE: {
            GET: `${origin}/api/get-prizes`
        },
        TAX: {
            GET_PROFILE: `${origin}/api/get-profile`,
            UPDATE_PROFILE: `${origin}/api/update-profile`,
            PULL_PROFILE: `${origin}/api/pull-profile`,
            GET_INTERVIEW: `${origin}/api/get-interview`,
            GET_CONSENT_INTERVIEW: `${origin}/api/get-consent-interview`,
            TRACE_TAKE_INTERVIEW: `${origin}/api/trace-take-interview`,
            GET_PAYOUT_ACCOUNT_STATUS: `${origin}/api/get-account-status`,
            GET_TAX_DOCUMENTS: `${origin}/api/get-tax-documents`,
            DOWNLOAD_TAX_PROFILE: `${origin}/api/download-tax-profile`,
            GET_RETAKE_AVAILABLE: `${origin}/api/get-retake-available`
        },
        PARTICIPATION: {
            GET_FORM: `${origin}/api/participation-get`,
            SAVE_FORM: `${origin}/api/participation-save`
        },
        SUPPORT: `${origin}/api/support`,
        LEGAL: {
            GET_GUARDIAN: `${origin}/api/get-guardian-info`,
            SAVE_GUARDIAN: `${origin}/api/update-guardian-info`
        }
    };
}
